module.exports = __webpack_public_path__ + "assets/6e07d822f3799bf4d06ea66d06b8b1b8.png";